module.exports = __webpack_public_path__ + "static/media/robot.addd9445.svg";